const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5809,
    cy: 32.1451,
    rx: 22.4227,
    ry: 22.5882,
    fill: "#CFB88D",
    fillOpacity: 0.28,
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.7332,
    cy: 2.38077,
    rx: 2.36332,
    ry: 2.38077,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.4537,
    cy: 17.6646,
    rx: 2.58723,
    ry: 2.60634,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.36105,
    cy: 32.8521,
    rx: 2.13889,
    ry: 2.15468,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0233,
    cy: 58.7512,
    rx: 2.58723,
    ry: 2.60634,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.004,
    cy: 48.0169,
    rx: 2.58723,
    ry: 2.60634,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9176,
    cy: 57.0492,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.5541,
    cy: 15.0591,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.1783,
    cy: 35.91,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5712,
    cy: 47.4938,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.62,
    cy: 12.4526,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.8993,
    cy: 6.20258,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5712,
    cy: 13.3219,
    rx: 0.862412,
    ry: 0.868779,
    fill: "#CFB88D",
    style: {
      fill: "#CFB88D",
      fill: "color(display-p3 0.8118 0.7216 0.5529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5813 46.6248C43.5196 46.6248 49.9548 40.142 49.9548 32.1451C49.9548 24.1482 43.5196 17.6655 35.5813 17.6655C27.643 17.6655 21.2078 24.1482 21.2078 32.1451C21.2078 40.142 27.643 46.6248 35.5813 46.6248Z",
    fill: "url(#paint0_linear_1082_25268)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8041 38.1932L27.3887 33.5056C26.7842 32.8639 26.8189 31.8485 27.4659 31.2489C28.1129 30.6493 29.1365 30.6839 29.741 31.3255L33.1469 34.9412L38.538 29.945C38.5865 29.9 38.6371 29.8588 38.6895 29.8209L41.2247 27.4714C41.8717 26.8718 42.8955 26.9063 43.4999 27.5481C44.1044 28.1897 44.0696 29.2052 43.4227 29.8048L35.6795 36.9809L35.6712 36.9721L32.9927 39.4544L31.8041 38.1932Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3097 60.5686L36.09 59.0767L37.0263 60.5686L38.7429 60.8669L37.3384 62.0604L37.6506 63.9998L36.09 63.1047L34.3734 63.9998L34.6855 62.0604L33.281 60.8669L35.3097 60.5686Z",
    fill: "#59462E",
    style: {
      fill: "#59462E",
      fill: "color(display-p3 0.3490 0.2745 0.1804)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86692 21.4121L3.44186 20.2713L4.13179 21.4121L5.39666 21.6403L4.36176 22.5529L4.59174 24.036L3.44186 23.3515L2.17699 24.036L2.40696 22.5529L1.37207 21.6403L2.86692 21.4121Z",
    fill: "#59462E",
    style: {
      fill: "#59462E",
      fill: "color(display-p3 0.3490 0.2745 0.1804)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4666 2.23773L36.9594 1.18466L37.5508 2.23773L38.6349 2.44834L37.7479 3.29079L37.945 4.65978L36.9594 4.02794L35.8752 4.65978L36.0724 3.29079L35.1853 2.44834L36.4666 2.23773Z",
    fill: "#59462E",
    style: {
      fill: "#59462E",
      fill: "color(display-p3 0.3490 0.2745 0.1804)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3446 27.3537L65.1249 25.7741L66.0612 27.3537L67.7779 27.6697L66.3734 28.9333L66.6855 30.9868L65.1249 30.0391L63.4083 30.9868L63.7204 28.9333L62.3159 27.6697L64.3446 27.3537Z",
    fill: "#59462E",
    style: {
      fill: "#59462E",
      fill: "color(display-p3 0.3490 0.2745 0.1804)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1082_25268",
    x1: 35.5813,
    y1: 17.6655,
    x2: 35.5813,
    y2: 46.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.0c164fd90e3a00b9da2a52dca2fbcde3.svg";
export { ForwardRef as ReactComponent };